import { graphql } from "relay-runtime"

export const chVerifyHealthInformationMutation = graphql`
  mutation chVerifyHealthInformationMutation($input: Ch_verifyHealthInformationInput!) {
    verifyHealthInformation: ch_verifyHealthInformation(input: $input) {
      verifyHealthInformationOutput {
        healthInformationLastVerification {
          id
          patientId
          healthInformationType
          verifiedAt
          verifiedBy
        }
        healthInformationVerification {
          id
          patientId
          appointmentId
          healthInformationType
          verifiedAt
          verifiedBy
        }
      }
    }
  }
`
